import script from "./GenericModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericModal.vue?vue&type=script&setup=true&lang=js"

import "./GenericModal.vue?vue&type=style&index=0&id=555db1be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555db1be"]])

export default __exports__